export const scadaKeys = {
    all: ['scada'] as const,
    graphs: () => [...scadaKeys.all, 'graph'] as const,
    graph: (assetId: string) => [...scadaKeys.graphs(), assetId] as const,
    live: (id: string, plantId: string) =>
        [...scadaKeys.all, 'live', plantId, id] as const,
    historical: () => [...scadaKeys.all, 'historical'] as const,
    historicalData: (id: string, plantId: string, timestamp: number) =>
        [...scadaKeys.historical(), plantId, id, timestamp] as const,
    entities: () => [...scadaKeys.all, 'entity'] as const,
    entity: (entityId: string) => [...scadaKeys.entities(), entityId] as const,
    pages: () => [...scadaKeys.all, 'pages'] as const,
    pagesList: (workspaceId: string) => [...scadaKeys.pages(), 'list', workspaceId] as const,
    pagesSearch: (workspaceId: string, query: string) =>
        [...scadaKeys.pages(), 'search', workspaceId, query] as const,
} as const;

export type ScadaQueryKeys = typeof scadaKeys;
